"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const definitions_1 = require("../definitions");
class AuthBase {
    constructor(storage, http, bitloopsConfig) {
        this.bitloopsConfig = bitloopsConfig;
        this.storage = storage;
        this.http = http;
    }
    /**
     * Tries to refresh token, token must be signed for our clientId,
     * and not expired for success
     */
    async refreshToken() {
        var _a;
        const { bitloopsConfig: config } = this;
        const url = `${(config === null || config === void 0 ? void 0 : config.ssl) === false ? 'http' : 'https'}://${config === null || config === void 0 ? void 0 : config.server}/bitloops/auth/refreshToken`;
        const user = await this.storage.getUser();
        if (((_a = config.auth) === null || _a === void 0 ? void 0 : _a.authenticationType) !== definitions_1.AuthTypes.User) {
            throw new Error('Attempt to refresh token for non BitloopsUser AuthType');
        }
        if (!(user === null || user === void 0 ? void 0 : user.refreshToken))
            throw new Error('no refresh token');
        const body = {
            refreshToken: user.refreshToken,
            clientId: config === null || config === void 0 ? void 0 : config.auth.clientId,
            providerId: config === null || config === void 0 ? void 0 : config.auth.providerId,
        };
        const { data: response, error } = await this.http.handlerWithoutRetries({
            url,
            method: 'POST',
            data: body,
        });
        if (error || response === null) {
            console.log('Refresh token was invalid', error);
            // invalid refresh token
            // clean refresh_token
            // logout user
            await this.clearAuthentication();
            return Promise.reject(error);
        }
        const newAccessToken = response.data.accessToken;
        const newRefreshToken = response.data.refreshToken;
        const newUser = {
            ...user,
            accessToken: newAccessToken,
            refreshToken: newRefreshToken,
        };
        console.log('Updated refresh token');
        await this.storage.saveUser(newUser);
        return newUser;
    }
}
exports.default = AuthBase;
//# sourceMappingURL=AuthBase.js.map